<template>
  <h1>Work in Progress</h1>
</template>

<script>
export default {
  name: "Index"
}
</script>

<style scoped>

</style>
